export const formatNote = (value: number) => {
  return Number(value).toLocaleString("fr-FR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
};
